import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Box } from '../box'
import { Text } from '../text'
import type { TextSize, TextTone } from '../text/variants'

export type ByAtTextProps = {
    by?: string
    at?: string
    emptyLabel?: string
    size?: TextSize
    tone?: TextTone
    className?: string
}

export const ByAtText: React.FC<ByAtTextProps> = ({
    by,
    at,
    emptyLabel,
    size = 'body',
    tone = 'default',
    className,
}) => {
    if (!by && !at) {
        return (
            <Text size={size} tone='muted' className={className}>
                {emptyLabel ?? '—'}
            </Text>
        )
    }

    return (
        <Box className={twMerge('gap-0.5', className)}>
            {!!by && (
                <Text size={size} tone={tone}>
                    {by}
                </Text>
            )}
            {!!at && (
                <Text size={size} tone={tone}>
                    {at}
                </Text>
            )}
        </Box>
    )
}

ByAtText.displayName = 'ByAtText'
